import type { RequirementItem } from "./types";

export const requirements: RequirementItem[] = [
  {
    title: "Оригинальность",
    text: "должна составлять не менее 75% (при проверке в системе Антиплагиат).",
  },
  {
    title: "Тезисы доклада/выступления",
    text:
      "представляются в виде НЕ архивированного прикрепленного файла формата *.doc/docx, где название файла – фамилия(-и), инициалы автора(-ров) – «Иванов А.А. Тезисы.doc» или «Иванов А.А., Петрова А.А.Тезисы doc».",
  },
  {
    title: "Тезисы должны иметь объем",
    text:
      "не менее 5 страниц с учетом таблиц и рисунков и обязательно включать «Аннотацию» и «Ключевые слова», дублированные на русском и английском языках «Annotation» и «Keywords».",
  },
  {
    title: "Набор",
    text: "в редакторе MS Word. Шрифт: Times New Roman. Размер шрифта 14.",
  },
  {
    title: "Отступ со всех сторон",
    text: "2,0.",
  },
  {
    title: "Интервал между строками",
    text: "1,5.",
  },
  {
    title: "Абзацный отступ",
    text: "(красная строка) автоматически: 1,25.",
  },
];
